import React, { useEffect, useRef } from "react";
import Jazzicon from "@metamask/jazzicon";
import { sizes, Image, Layout } from "./styles";

import { AvatarSizes, AvatarTypeProps } from "./types";

const Avatar = ({ size = AvatarSizes.MEDIUM, hash, image, alt, id }: AvatarTypeProps) => {
  const placeholderRef = useRef<HTMLDivElement>(null);
  const sizeVal = typeof size === "number" ? size : sizes[size];

  useEffect(() => {
    if (!image && placeholderRef.current && hash) {
      placeholderRef.current.innerHTML = "";
      placeholderRef.current.appendChild(Jazzicon(sizeVal, parseInt(hash.slice(2, 10), 16)));
    }
  }, [image, hash, size]);

  return (
    <Layout size={sizeVal} data-testid="avatar-view" id={id}>
      {image ? (
        <Image src={image} alt={alt} />
      ) : (
        <div data-testid="icon-input" ref={placeholderRef} />
      )}
    </Layout>
  );
};

export { AvatarSizes };
export default Avatar;
